/* Publish by EComposer at 2025-08-08 09:52:53*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2j730kz0mtw"]=  window.__ectimmers["ecom-2j730kz0mtw"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-2j730kz0mtw"]["ufgteixqe"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-2j730kz0mtw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2j730kz0mtw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jsh5p92m9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jsh5p92m9p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o0mweh4daph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o0mweh4daph', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8jilxf093bk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8jilxf093bk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ojph6vuf3he').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ojph6vuf3he', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5fmx7fa8g0m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5fmx7fa8g0m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3uhyvv31g1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3uhyvv31g1g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rniuqnuijhf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rniuqnuijhf', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ho7tr372jw"]=  window.__ectimmers["ecom-ho7tr372jw"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ho7tr372jw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ho7tr372jw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmhhj4bxu9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmhhj4bxu9c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zmm9zqmgy5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zmm9zqmgy5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nbrulfppqqo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nbrulfppqqo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m1ehvlt4rjo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m1ehvlt4rjo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmogcvutxlo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmogcvutxlo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ug3bcq3lgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ug3bcq3lgh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-onr2nls8nj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-onr2nls8nj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-svnw8rewin').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-svnw8rewin', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38sye2x24mf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38sye2x24mf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-abm48k38qu7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-abm48k38qu7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aib5ro42uwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aib5ro42uwk', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tqz51dqngyb"]=  window.__ectimmers["ecom-tqz51dqngyb"] || {};
if(!this.$el||!window.EComModal)return;const e=this.isLive;let i=this.$el.querySelectorAll("[ecom-modal]");i.length&&e&&new window.EComModal(i,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-tqz51dqngyb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tqz51dqngyb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f164eylrruv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f164eylrruv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vthe9p8o1el').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vthe9p8o1el', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oav63czqhz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oav63czqhz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u08s7cmjmva').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u08s7cmjmva', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-x3oo8l9ce0o"]=  window.__ectimmers["ecom-x3oo8l9ce0o"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-x3oo8l9ce0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3oo8l9ce0o', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}